var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2a8 8 0 00-8 8 8 8 0 008 8 8 8 0 008-8 8 8 0 00-8-8zm0 14.5A6.507 6.507 0 013.5 10c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zm0-4c-.563 0-1 .438-1 1 0 .563.41 1 1 1 .534 0 1-.438 1-1 0-.563-.466-1-1-1zM11.034 6H9.437A2.174 2.174 0 007.25 8.188c0 .406.344.75.75.75a.76.76 0 00.75-.75c0-.376.284-.688.66-.688h1.596c.403 0 .744.313.744.688 0 .25-.125.44-.344.565l-1.781 1.09a.77.77 0 00-.375.657v.5c0 .406.344.75.75.75a.76.76 0 00.75-.75v-.063l1.41-.874a2.23 2.23 0 001.062-1.876C13.25 6.97 12.282 6 11.034 6z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default ForwardRef;